//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.DisplayResolutionBuilder.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"AutomaticUpdate",1,0],[1,"DisplayResolution",0,"GeometricUtilities.DisplayResolutionBuilder",0],[0,"FailedSegmentsColor",1,0],[0,"MaximumWidth",1,0],[0,"MinimumRatio",1,0],[0,"Orientation",1,0],[0,"Origin",1,0],[0,"PassedSegmentsColor",1,0],[0,"PreviewState",1,0],[0,"SegmentLength",1,0],[0,"ShowOnlyFailedSegments",1,0]],[[["numberOfData","tableData"],"GetTableData",{},0,0],[["tableData"],"SetTableData",{},1,0],[["nFaces"],"GetFaces",{R_:{faces:"Face[]"}},0,0],[["faces"],"SetFaces",{},1,0],[["nBodies"],"GetBodies",{R_:{bodies:"Body[]"}},0,0],[["bodies"],"SetBodies",{},1,0],[["needRegenerateFacets"],"SetNeedRegenerateFacets",{},1,0]],[]];
SPLM.Validate.CheckChannelRatioBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.CheckChannelRatioBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.CheckChannelRatioBuilder.TableData = class{
    constructor(angle,minimumDiameter){
        this.angle=angle;this.minimumDiameter=minimumDiameter;}
    get Angle(){return this.angle}
    set Angle(val){this.angle = val}
    get Minimumdiameter(){return this.minimumDiameter}
    set Minimumdiameter(val){this.minimumDiameter = val}
};

export default SPLM;